<template>
  <div>
    <kaidan :order_type="0" > </kaidan> 
    <!-- mac_manage_flag 用于下级页面接收的参数 -->
  </div>
</template>
<script>
import kaidan from '../../tongyong/kaidan.vue'
 
export default {

  components: {
    kaidan: kaidan 
  },

  data() {
    return {
      // 获取用户列表参数
      
    };
  },
  props: [],
 
  watch: {
 
  },
  created() {
 
  },
  mounted() {
 
  }
}
</script>
